import React from 'react';
import { Route } from 'react-router-dom';
const Page403 = React.lazy(() => import('src/views/pages/page403/Page403'));
export const PrivateRoute = ({ component: Component, hasPermissions, ...rest }) => (
  <Route {...rest} render={props => {
    return hasPermissions ? <Component {...props} /> : <><Page403/></>
  }} />
)